import * as tslib_1 from "tslib";
import { CommandContainer } from './command_container';
var ContextMenu = /** @class */ (function (_super) {
    tslib_1.__extends(ContextMenu, _super);
    function ContextMenu(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'target,position';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = obj[key];
            }
        });
        return _this;
    }
    ContextMenu.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), {
            "type": "ContextMenu",
            "target": this.target,
            "position": this.position
        });
    };
    ContextMenu.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ContextMenu;
}(CommandContainer));
export { ContextMenu };
//# sourceMappingURL=context_menu.js.map